module.exports = ":host >>> .popover {\n  background-color: #2e2e46;\n  color: #2e2e46;\n  max-width: 100%; /* Max Width of the popover (depending on the container!) */\n}\n:host >>> .popover>.arrow:after {\n  border-top-color: #2e2e46;\n}\n.popover {\n  background-color: #2e2e46;\n  color: #2e2e46;\n  max-width: 100%; /* Max Width of the popover (depending on the container!) */\n}\n.popover>.arrow:after {\n  border-top-color: #2e2e46;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/operation-info/operation-info.component.css
// module id = ./src/app/achelos-iot/operation-info/operation-info.component.css
// module chunks = main